<div class="d-flex gap-3">
  <magieno-input-money-field
          class="flex-fill"
          [advancedFormControl]="this.campForm.formElements.careExpenses | asAdvancedFormControl"
                             [currency]="this.currency"
                             [locale]="this.locale"></magieno-input-money-field>

  <magieno-input-number-field
          class="flex-fill"
          [advancedFormControl]="this.campForm.formElements.numberOfWeeks | asAdvancedFormControl"></magieno-input-number-field>
</div>




